<template>
  <div>
    <a class="footer-menu" href="https://wa.me/+573505529223" target="_blank">
      <i class="pi pi-whatsapp" style="color: #fff"></i>
      <p>Soporte</p>
    </a>
  </div>
</template>

<script>
export default {
  name: "ChatWComponent.vue"
}
</script>

<style scoped>

</style>